import { render, staticRenderFns } from "./classicCaseDetail.vue?vue&type=template&id=070fdc36&scoped=true"
import script from "./classicCaseDetail.vue?vue&type=script&lang=js"
export * from "./classicCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./classicCaseDetail.vue?vue&type=style&index=0&id=070fdc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fdc36",
  null
  
)

export default component.exports